<template>
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.2"
      d="M4.23438 10.4668V15.3652C4.23408 15.5202 4.2842 15.6711 4.37718 15.7952C4.98243 16.6006 7.53587 19.547 12.5 19.547C17.4641 19.547 20.0176 16.6006 20.6228 15.7952C20.7158 15.6711 20.7659 15.5202 20.7656 15.3652V10.4668L12.5 14.8751L4.23438 10.4668Z"
      fill="white"
    />
    <path
      d="M1.71875 9.125L12.5 3.375L23.2812 9.125L12.5 14.875L1.71875 9.125Z"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M17.8906 22.0625V12L12.5 9.125"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M20.7656 10.4668V15.3652C20.7659 15.5202 20.7158 15.6711 20.6228 15.7952C20.0176 16.6006 17.4641 19.547 12.5 19.547C7.53587 19.547 4.98243 16.6006 4.37718 15.7952C4.2842 15.6711 4.23408 15.5202 4.23438 15.3652V10.4668"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
<script>
export default {
  name: "SchoolIcon",
  props: {
    color: {
      type: String,
      default: "#5fae32",
    },
  },
}
</script>
